import { apiTokenWrapper } from 'api/ApiTokenWrapper'

export const getResponsePidData = (requestString: string) => {
  const url = `/data/${requestString}?isResponse=true`;
  return apiTokenWrapper.get(url)
}
